module.exports = __webpack_public_path__ + "img/img-4.5a9a1705.jpg";